// initial redux state
const initial = {
	players: [
	],
}

export default initial;